import {
  FETCHIBEACONS,
  FETCHIBEACONS_SUCCESS,
  FETCHEDDYSTONES,
  FETCHEDDYSTONES_SUCCESS,
  FETCHREADERS,
  FETCHREADERS_SUCCESS,
  FETCHHUBS,
  FETCHHUBS_SUCCESS,
  FETCHGATEWAYS,
  FETCHGATEWAYS_SUCCESS,
  FETCHIBEACON,
  FETCHIBEACON_SUCCESS,
  FETCHEDDYSTONE,
  FETCHEDDYSTONE_SUCCESS,
  FETCHREADER,
  FETCHREADER_SUCCESS,
  FETCHHUB,
  FETCHHUB_SUCCESS,
  FETCHGATEWAY,
  FETCHGATEWAY_SUCCESS,
  FETCHMODELS,
  FETCHMODELS_SUCCESS,
  CREATEDEVICE,
  CREATEDEVICE_SUCCESS,
  UPDATEDEVICE,
  UPDATEDEVICE_SUCCESS,
  DELETEDEVICE,
  DELETEDEVICE_SUCCESS,
  CREATEIBEACON,
  CREATEIBEACON_SUCCESS,
  UPDATEIBEACON,
  UPDATEIBEACON_SUCCESS,
  DELETEIBEACON,
  DELETEIBEACON_SUCCESS,
  CREATEEDDYSTONE,
  CREATEEDDYSTONE_SUCCESS,
  UPDATEEDDYSTONE,
  UPDATEEDDYSTONE_SUCCESS,
  DELETEEDDYSTONE,
  DELETEEDDYSTONE_SUCCESS,
  CREATEREADER,
  CREATEREADER_SUCCESS,
  UPDATEREADER,
  UPDATEREADER_SUCCESS,
  DELETEREADER,
  DELETEREADER_SUCCESS,
  CREATEHUB,
  CREATEHUB_SUCCESS,
  UPDATEHUB,
  UPDATEHUB_SUCCESS,
  DELETEHUB,
  DELETEHUB_SUCCESS,
  CREATEGATEWAY,
  CREATEGATEWAY_SUCCESS,
  UPDATEGATEWAY,
  UPDATEGATEWAY_SUCCESS,
  DELETEGATEWAY,
  DELETEGATEWAY_SUCCESS,
  CREATEDEVICES,
  CREATEDEVICESPARALLEL,
  CREATEDEVICES_SUCCESS,
  CREATEDEVICESPARALLEL_SUCCESS,
  DELETEDEVICES,
  DELETEDEVICES_SUCCESS,
  VALIDATEDEVICES,
  VALIDATEDEVICES_SUCCESS,
  UPDATESHADOW,
  UPDATESHADOW_SUCCESS,
  OTAUPDATE,
  OTAUPDATE_SUCCESS,
  FETCHDEVICELOGS,
  FETCHDEVICELOGS_SUCCESS,
  CREATEMESHELEMENT,
  CREATEMESHELEMENT_SUCCESS,
  UPDATEMESHELEMENT,
  UPDATEMESHELEMENT_SUCCESS,
  DELETEMESHELEMENT,
  DELETEMESHELEMENT_SUCCESS,
  FETCHWIFITESTS,
  FETCHWIFITESTS_SUCCESS,
  FETCHSENSORS,
  FETCHSENSORS_SUCCESS,
  FETCHNFCTAGS,
  FETCHNFCTAGS_SUCCESS,
  FETCHNFCTAGSCONNECTION,
  FETCHNFCTAGSCONNECTION_SUCCESS,
  COUNTNFCTAGSLATLNG,
  COUNTNFCTAGSLATLNG_SUCCESS,
  FETCHLIGHTINGS,
  FETCHLIGHTINGS_SUCCESS,
  OPENBUZZVOXLOCK,
  OPENBUZZVOXLOCK_SUCCESS,
  COUNTSERIALRANGE,
  COUNTSERIALRANGE_SUCCESS,
  GETSERIALRANGE,
  GETSERIALRANGE_SUCCESS
} from "constants/ActionTypes";

export const fetchIBeacons = (applicationId) => {
  return {
    type: FETCHIBEACONS,
    payload: {
      applicationId: applicationId
    }
  };
};

export const fetchIBeaconsSuccess = (applicationId, devices) => {

  return {
    type: FETCHIBEACONS_SUCCESS,
    applicationId: applicationId,
    payload: devices
  };
};

export const fetchEddystones = (applicationId) => {
  return {
    type: FETCHEDDYSTONES,
    payload: {
      applicationId: applicationId
    }
  };
};

export const fetchEddystonesSuccess = (applicationId, devices) => {

  return {
    type: FETCHEDDYSTONES_SUCCESS,
    applicationId: applicationId,
    payload: devices
  };
};

export const fetchReaders = (applicationId) => {
  return {
    type: FETCHREADERS,
    payload: {
      applicationId: applicationId
    }
  };
};

export const fetchReadersSuccess = (applicationId, devices) => {

  return {
    type: FETCHREADERS_SUCCESS,
    applicationId: applicationId,
    payload: devices
  };
};

export const fetchHubs = (applicationId) => {
  console.log('fetchHubs', applicationId);
  return {
    type: FETCHHUBS,
    payload: {
      applicationId: applicationId
    }
  };
};

export const fetchHubsSuccess = (applicationId, devices) => {

  return {
    type: FETCHHUBS_SUCCESS,
    applicationId: applicationId,
    payload: devices
  };
};

export const fetchGateways = (applicationId) => {
  console.log('fetchGateways', applicationId);

  return {
    type: FETCHGATEWAYS,
    payload: {
      applicationId: applicationId
    }
  };
};

export const fetchGatewaysSuccess = (applicationId, devices) => {

  return {
    type: FETCHGATEWAYS_SUCCESS,
    applicationId: applicationId,
    payload: devices
  };
};


export const fetchIBeacon = (deviceId) => {
  return {
    type: FETCHIBEACON,
    payload: {
      deviceId: deviceId
    }
  };
};

export const fetchIBeaconSuccess = (deviceId, device) => {

  return {
    type: FETCHIBEACON_SUCCESS,
    deviceId: deviceId,
    payload: device
  };
};

export const fetchEddystone = (deviceId) => {
  return {
    type: FETCHEDDYSTONE,
    payload: {
      deviceId: deviceId
    }
  };
};

export const fetchEddystoneSuccess = (deviceId, device) => {
  return {
    type: FETCHEDDYSTONE_SUCCESS,
    deviceId: deviceId,
    payload: device
  };
};

export const fetchReader = (deviceId) => {
  return {
    type: FETCHREADER,
    payload: {
      deviceId: deviceId
    }
  };
};

export const fetchReaderSuccess = (deviceId, device) => {

  return {
    type: FETCHREADER_SUCCESS,
    deviceId: deviceId,
    payload: device
  };
};

export const fetchHub = (deviceId) => {
  return {
    type: FETCHHUB,
    payload: {
      deviceId: deviceId
    }
  };
};

export const fetchHubSuccess = (deviceId, device) => {
  return {
    type: FETCHHUB_SUCCESS,
    deviceId: deviceId,
    payload: device
  };
};

export const fetchGateway = (deviceId) => {
  return {
    type: FETCHGATEWAY,
    payload: {
      deviceId: deviceId
    }
  };
};

export const fetchGatewaySuccess = (deviceId, device) => {
  console.log('fetchGatewaySuccess', deviceId, device)

  return {
    type: FETCHGATEWAY_SUCCESS,
    deviceId: deviceId,
    payload: device
  };
};

export const fetchModels = () => {
  return {
    type: FETCHMODELS,
    payload: {
    }
  };
};

export const fetchModelsSuccess = (models) => {

  return {
    type: FETCHMODELS_SUCCESS,
    payload: models
  };
};

export const createDevices = (creatingDevices, index) => {

  return {
    type: CREATEDEVICES,
    payload: creatingDevices,
    index
  };
};

export const createDevicesParallel = (startSerialNumber, quantity, noOfSubBatch, model,
application, args, batchIndex) => {

  return {
    type: CREATEDEVICESPARALLEL,
    startSerialNumber, quantity, noOfSubBatch, model,
    application, args, batchIndex
  }
};

export const createDevicesSuccess = (createdDevices, index) => {
  console.log('createDevicesSuccess', createdDevices, index);

  return {
    type: CREATEDEVICES_SUCCESS,
    payload: "success",
    index
  };
};

export const createDevicesParallelSuccess = (createdDevices) => {
  console.log('createDevicesParallelSuccess', createdDevices);

  return {
    type: CREATEDEVICESPARALLEL_SUCCESS,
    payload: createdDevices,
  };
};

export const createIBeacon = (creatingDevice) => {

  return {
    type: CREATEIBEACON,
    payload: creatingDevice
  };
};

export const createIBeaconSuccess = (createdDevice) => {

  return {
    type: CREATEIBEACON_SUCCESS,
    payload: createdDevice
  };
};

export const updateIBeacon = (updatingDevice) => {

  return {
    type: UPDATEIBEACON,
    payload: updatingDevice
  };
};

export const updateIBeaconSuccess = (updatedDevice) => {

  return {
    type: UPDATEIBEACON_SUCCESS,
    payload: updatedDevice
  };
};

export const deleteIBeacon = (deletingDevice) => {

  return {
    type: DELETEIBEACON,
    payload: deletingDevice
  };
};

export const deleteIBeaconSuccess = (deletedDevice) => {

  return {
    type: DELETEIBEACON_SUCCESS,
    payload: deletedDevice
  };
};


export const createEddystone = (creatingDevice) => {

  return {
    type: CREATEEDDYSTONE,
    payload: creatingDevice
  };
};

export const createEddystoneSuccess = (createdDevice) => {

  return {
    type: CREATEEDDYSTONE_SUCCESS,
    payload: createdDevice
  };
};

export const updateEddystone = (updatingDevice) => {

  return {
    type: UPDATEEDDYSTONE,
    payload: updatingDevice
  };
};

export const updateEddystoneSuccess = (updatedDevice) => {

  return {
    type: UPDATEEDDYSTONE_SUCCESS,
    payload: updatedDevice
  };
};

export const deleteEddystone = (deletingDevice) => {

  return {
    type: DELETEEDDYSTONE,
    payload: deletingDevice
  };
};

export const deleteEddystoneSuccess = (deletedDevice) => {

  return {
    type: DELETEEDDYSTONE_SUCCESS,
    payload: deletedDevice
  };
};


export const createReader = (creatingDevice) => {

  return {
    type: CREATEREADER,
    payload: creatingDevice
  };
};

export const createReaderSuccess = (createdDevice) => {

  return {
    type: CREATEREADER_SUCCESS,
    payload: createdDevice
  };
};

export const updateReader = (updatingDevice) => {

  return {
    type: UPDATEREADER,
    payload: updatingDevice
  };
};

export const updateReaderSuccess = (updatedDevice) => {

  return {
    type: UPDATEREADER_SUCCESS,
    payload: updatedDevice
  };
};

export const deleteReader = (deletingDevice) => {

  return {
    type: DELETEREADER,
    payload: deletingDevice
  };
};

export const deleteReaderSuccess = (deletedDevice) => {

  return {
    type: DELETEREADER_SUCCESS,
    payload: deletedDevice
  };
};


export const createBluetoothHub = (creatingDevice) => {

  return {
    type: CREATEHUB,
    payload: creatingDevice
  };
};

export const createBluetoothHubSuccess = (createdDevice) => {

  return {
    type: CREATEHUB_SUCCESS,
    payload: createdDevice
  };
};

export const updateBluetoothHub = (updatingDevice) => {

  return {
    type: UPDATEHUB,
    payload: updatingDevice
  };
};

export const updateBluetoothHubSuccess = (updatedDevice) => {

  return {
    type: UPDATEHUB_SUCCESS,
    payload: updatedDevice
  };
};

export const deleteBluetoothHub = (deletingDevice) => {

  return {
    type: DELETEHUB,
    payload: deletingDevice
  };
};

export const deleteBluetoothHubSuccess = (deletedDevice) => {

  return {
    type: DELETEHUB_SUCCESS,
    payload: deletedDevice
  };
};

export const createGateway = (creatingDevice) => {

  return {
    type: CREATEGATEWAY,
    payload: creatingDevice
  };
};

export const createGatewaySuccess = (createdDevice) => {

  return {
    type: CREATEGATEWAY_SUCCESS,
    payload: createdDevice
  };
};

export const updateGateway = (updatingDevice) => {

  return {
    type: UPDATEGATEWAY,
    payload: updatingDevice
  };
};

export const updateGatewaySuccess = (updatedDevice) => {

  return {
    type: UPDATEGATEWAY_SUCCESS,
    payload: updatedDevice
  };
};

export const deleteGateway = (deletingDevice) => {

  return {
    type: DELETEGATEWAY,
    payload: deletingDevice
  };
};

export const deleteGatewaySuccess = (deletedDevice) => {
  return {
    type: DELETEGATEWAY_SUCCESS,
    payload: deletedDevice
  };
};

export const deleteDevices = (type, deviceIds) => {
  return {
    type: DELETEDEVICES,
    payload: {
      type, deviceIds
    }
  };
};

export const deleteDevicesSuccess = (deletedDevices) => {
  return {
    type: DELETEDEVICES_SUCCESS,
    payload: deletedDevices
  };
};

export const validateDevices = (type, devices) => {
  return {
    type: VALIDATEDEVICES,
    payload: {
      type, devices
    }
  };
};

export const validateDevicesSuccess = (validatedDevices) => {
  return {
    type: VALIDATEDEVICES_SUCCESS,
    payload: validatedDevices
  };
};

export const updateShadow = (updatingShadow) => {

  return {
    type: UPDATESHADOW,
    payload: updatingShadow
  };
};

export const updateShadowSuccess = (updatedShadow) => {

  return {
    type: UPDATESHADOW_SUCCESS,
    payload: updatedShadow
  };
};

export const otaUpdate = (otaUpdating) => {

  return {
    type: OTAUPDATE,
    payload: otaUpdating
  };
};

export const otaUpdateSuccess = (otaUpdated) => {

  return {
    type: OTAUPDATE_SUCCESS,
    payload: otaUpdated
  };
};

export const fetchDeviceLogs = (deviceId) => {
  return {
    type: FETCHDEVICELOGS,
    payload: {
      deviceId: deviceId
    }
  };
};

export const fetchDeviceLogsSuccess = (deviceId, deviceLogs) => {
  return {
    type: FETCHDEVICELOGS_SUCCESS,
    deviceId: deviceId,
    payload: deviceLogs
  };
};

export const createMeshElement = (creatingMeshElement) => {

  return {
    type: CREATEMESHELEMENT,
    payload: creatingMeshElement
  };
};

export const createMeshElementSuccess = (createdMeshElement) => {

  return {
    type: CREATEMESHELEMENT_SUCCESS,
    payload: createdMeshElement
  };
};

export const updateMeshElement = (updatingMeshElement) => {

  return {
    type: UPDATEMESHELEMENT,
    payload: updatingMeshElement
  };
};

export const updateMeshElementSuccess = (updatedMeshElement) => {

  return {
    type: UPDATEMESHELEMENT_SUCCESS,
    payload: updatedMeshElement
  };
};

export const deleteMeshElement = (deletingMeshElement) => {

  return {
    type: DELETEMESHELEMENT,
    payload: deletingMeshElement
  };
};

export const deleteMeshElementSuccess = (deletedMeshElement) => {
  return {
    type: DELETEMESHELEMENT_SUCCESS,
    payload: deletedMeshElement
  };
};

export const fetchWifiTests = (applicationId) => {
  return {
    type: FETCHWIFITESTS,
    payload: {
      applicationId: applicationId
    }
  };
};

export const fetchWifiTestsSuccess = (applicationId, wifiTests) => {
  return {
    type: FETCHWIFITESTS_SUCCESS,
    applicationId,
    payload: wifiTests
  };
};

export const fetchSensors = (applicationId) => {
  return {
    type: FETCHSENSORS,
    payload: {
      applicationId: applicationId
    }
  };
};

export const fetchSensorsSuccess = (applicationId, devices) => {

  return {
    type: FETCHSENSORS_SUCCESS,
    applicationId: applicationId,
    payload: devices
  };
};

export const fetchNFCTags = (applicationId) => {
  return {
    type: FETCHNFCTAGS,
    payload: {
      applicationId: applicationId
    }
  };
};

export const fetchNFCTagsConnection = (applicationId, {first, last}, {before, after}, {models, searchParam,
searchTerm}) => {
  console.log('fetchNFCTagsConnection models', models);

  return {
    type: FETCHNFCTAGSCONNECTION,
    payload: {
      applicationId: applicationId
    },
    first,
    last,
    before,
    after,
    models,
    searchParam,
    searchTerm
  };
};

export const fetchNFCTagsSuccess = (applicationId, devices) => {

  return {
    type: FETCHNFCTAGS_SUCCESS,
    applicationId: applicationId,
    payload: devices
  };
};

export const fetchNFCTagsConnectionSuccess = (applicationId, first, last, before, after, models, searchParam, searchTerm, {getNFCTagsConnection}) => {
  console.log('fetchNFCTagsConnectionSuccess', applicationId, first, after, getNFCTagsConnection);

  return {
    type: FETCHNFCTAGSCONNECTION_SUCCESS,
    applicationId,
    first,
    last,
    before,
    after,
    models,
    searchParam,
    searchTerm,
    payload: getNFCTagsConnection
  };
};

export const countNFCTagsByLatLng = (applicationId, models) => {
  return {
    type: COUNTNFCTAGSLATLNG,
    payload: {
      applicationId: applicationId,
      models
    }
  };
};

export const countNFCTagsByLatLngSuccess = (applicationId, models, devices) => {

  return {
    type: COUNTNFCTAGSLATLNG_SUCCESS,
    applicationId,
    models,
    payload: devices
  };
};

export const countSerialRange = (applicationId, serialRangeStart, serialRangeEnd) => {
  console.log('countSerialRange', countSerialRange);

  return {
    type: COUNTSERIALRANGE,
    payload: {
      applicationId,
      serialRangeStart,
      serialRangeEnd
    }
  };
};

export const countSerialRangeSuccess = (applicationId, serialRangeStart, serialRangeEnd, {countSerialRange}) => {

  return {
    type: COUNTSERIALRANGE_SUCCESS,
    applicationId,
    serialRangeStart,
    serialRangeEnd,
    payload: countSerialRange
  };
};

export const getSerialRange = (applicationId, serialRangeStart, serialRangeEnd) => {
  console.log('getSerialRange', getSerialRange);

  return {
    type: GETSERIALRANGE,
    payload: {
      applicationId: applicationId
    }
  };
};

export const getSerialRangeSuccess = (applicationId, {getSerialRange}) => {

  return {
    type: GETSERIALRANGE_SUCCESS,
    applicationId: applicationId,
    payload: getSerialRange
  };
};

export const fetchLightings = (applicationId) => {
  return {
    type: FETCHLIGHTINGS,
    payload: {
      applicationId: applicationId
    }
  };
};

export const fetchLightingsSuccess = (applicationId, devices) => {

  return {
    type: FETCHLIGHTINGS_SUCCESS,
    applicationId: applicationId,
    payload: devices
  };
};

export const createDevice = (creatingDevice) => {

  return {
    type: CREATEDEVICE,
    payload: creatingDevice
  };
};

export const createDeviceSuccess = (createdDevice) => {

  return {
    type: CREATEDEVICE_SUCCESS,
    payload: createdDevice
  };
};

export const updateDevice = (updatingDevice) => {

  return {
    type: UPDATEDEVICE,
    payload: updatingDevice
  };
};

export const updateDeviceSuccess = (updatedDevice) => {

  return {
    type: UPDATEDEVICE_SUCCESS,
    payload: updatedDevice
  };
};

export const deleteDevice = (deletingDevice) => {

  return {
    type: DELETEDEVICE,
    payload: deletingDevice
  };
};

export const deleteDeviceSuccess = (deletedDevice) => {

  return {
    type: DELETEDEVICE_SUCCESS,
    payload: deletedDevice
  };
};

export const openBuzzVoxLock = (deviceId, macAddress, password) => {

  return {
    type: OPENBUZZVOXLOCK,
    payload: {
      deviceId,
      macAddress,
      password
    }
  };
};

export const openBuzzVoxLockSuccess = (job) => {

  return {
    type: OPENBUZZVOXLOCK_SUCCESS,
    payload: job
  };
};
